// ===================================================================
// KAIXO - HashtagView
// ===================================================================
// Overlay con los posts que contienen un #hashtag concreto. Se abre
// cuando el usuario toca un hashtag dentro de cualquier latido.
// ===================================================================

import React from 'react';
import { Icons } from '../Icons/Icons';
import { linkify } from '../../utils/linkify';
import LatidoCarousel from './LatidoCarousel';
import ct from './i18n';

export default function HashtagView({
    hashtagView,      // { tag, messages, loading }
    onClose,
    onOpenProfile,    // (inviteCodeOrHandle) => void
    onOpenImage,      // (url) => void
    onOpenVideo       // (url) => void
}) {
    if (!hashtagView) return null;

    return (
        <div className="v2-hashtag-overlay" onClick={onClose}>
            <div className="v2-hashtag-sheet" onClick={e => e.stopPropagation()}>
                <div className="v2-hashtag-header">
                    <h3>#{hashtagView.tag}</h3>
                    <button className="v2-icon-btn" onClick={onClose}>
                        <Icons.Close size={18} />
                    </button>
                </div>
                <div className="v2-hashtag-body">
                    {hashtagView.loading && <p className="v2-center">{ct.loading}</p>}
                    {!hashtagView.loading && hashtagView.messages.length === 0 && (
                        <p className="v2-center v2-dim">{ct.emptyFeed || 'Sin resultados'}</p>
                    )}
                    {!hashtagView.loading && hashtagView.messages.map(m => (
                        <div key={m._id} className="v2-feed-item">
                            <div
                                className="v2-feed-head"
                                onClick={() => {
                                    const code = m.channelInviteCode
                                        || (m.channelHandle ? `@${m.channelHandle}` : null);
                                    if (code) onOpenProfile(code);
                                }}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="v2-feed-avatar">
                                    {m.channelAvatar
                                        ? <img src={m.channelAvatar} alt="" loading="lazy" decoding="async" />
                                        : (m.channelName?.[0] || '?')}
                                </div>
                                <div className="v2-feed-meta">
                                    <strong>{m.channelName}</strong>
                                    <div className="v2-feed-time">
                                        {new Date(m.createdAt).toLocaleString()}
                                    </div>
                                </div>
                            </div>
                            {(() => {
                                if (Array.isArray(m.mediaUrls) && m.mediaUrls.length > 0) {
                                    return (
                                        <LatidoCarousel
                                            media={m.mediaUrls}
                                            onOpenImage={onOpenImage}
                                            onOpenVideo={onOpenVideo}
                                        />
                                    );
                                }
                                if (m.mediaType === 'image' && m.mediaUrl) {
                                    return (
                                        <img
                                            src={m.mediaUrl}
                                            alt=""
                                            loading="lazy"
                                            decoding="async"
                                            className="v2-feed-image"
                                            onClick={e => { e.stopPropagation(); onOpenImage(m.mediaUrl); }}
                                            style={{ cursor: 'pointer' }}
                                        />
                                    );
                                }
                                return null;
                            })()}
                            {m.text && <div className="v2-feed-text">{linkify(m.text)}</div>}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
